import { useEffect, useRef } from 'react-x';

export const useObserver = (
  { root=document, target, className='in-view', threshold=0.5} = {}, 
  callbackFn, 
  dependencies=[]
) => {

  const observer = useRef();
  
  const callback = (entries, _) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (typeof callbackFn === 'function') {
          callbackFn({ status: 'in-view', element: entry.target});
        }
        return entry.target.classList.add(className);
      }
      if (typeof callbackFn === 'function') {
        callbackFn({ status: 'out-of-view', element: entry.target});
      }
      return entry.target.classList.remove(className);
    });
  };

  const setupObserve = () => {
    observer.current = new IntersectionObserver(callback, {
      threshold: threshold,
    });

    const targets = root.querySelectorAll(`.${target}`);
    targets.forEach((item) => {
      observer.current.observe(item);
    });
  };

  useEffect(() => {
    if (target) {
      setupObserve();

      return () => {
        observer.current.disconnect();
       }
    }
  }, [...dependencies]);
};
